import styled from 'styled-components';
import Projects from '../../Sections/Projects/Projects';
import AboutMe from '../../Sections/AboutMe/AboutMe';
import Contact from '../../Sections/Contact/Contact';
import Skills from '../../Sections/Skills/Skills';
import Return from '../Helpers/Return';

const Container = (props) => {
  return (
    <div className={props.className}>
      <AboutMe />
      <Skills />
      <Projects />
      <Contact />
      <Return />
    </div>
  );
};

export default styled(Container)`
  width: 90%;
  margin: 0 auto;
  padding: 2rem;

  @media (max-width: 768px) {
    width: 100%;

    margin: 0 auto;
  } ;
`;
